// Menu data for the ordering system
// Each business has branches and categorised menu items

export const BUSINESSES = [
  {
    key: 'desres',
    label: 'Desres Kitchen',
    gateway: 'yoco',
    cardEnabled: false, // Yoco account not yet set up
    branches: [
      { key: 'limpopo', label: 'Limpopo', address: 'Limpopo, South Africa' },
      { key: 'pretoria', label: 'Pretoria', address: 'Pretoria, South Africa' },
    ],
    categories: [
      {
        key: 'meals',
        label: 'Traditional Meals',
        items: [
          { id: 'dk-1', name: 'Full Mukokoroshi', price: 85 },
          { id: 'dk-2', name: 'Half Mukokoroshi', price: 65 },
          { id: 'dk-3', name: 'Mukokoroshi Plate', price: 30 },
          { id: 'dk-4', name: 'Mukokoroshi (Single)', price: 18 },
          { id: 'dk-5', name: 'Full Steak', price: 85 },
          { id: 'dk-6', name: 'Half Steak', price: 65 },
          { id: 'dk-7', name: 'Full Stew Vors', price: 85 },
          { id: 'dk-8', name: 'Half Stew Vors', price: 65 },
          { id: 'dk-9', name: 'Khwandadza Khuhu x3', price: 12 },
          { id: 'dk-10', name: 'Khwanda Plate', price: 30 },
          { id: 'dk-11', name: 'Half Khwanda Dza Khuhu', price: 40 },
          { id: 'dk-12', name: 'Full Liver', price: 80 },
          { id: 'dk-13', name: 'Half Liver', price: 55 },
          { id: 'dk-14', name: 'Liver Plate', price: 30 },
          { id: 'dk-15', name: 'Full Mala A Khuhu', price: 75 },
          { id: 'dk-16', name: 'Half Mala A Khuhu', price: 50 },
          { id: 'dk-17', name: 'Mala Plate', price: 30 },
          { id: 'dk-18', name: 'Mashonzha Plate', price: 30 },
          { id: 'dk-19', name: 'Makhaha', price: 10 },
          { id: 'dk-20', name: 'Mutuku', price: 10 },
        ],
      },
      {
        key: 'bakes',
        label: 'Daily Bakes',
        items: [
          { id: 'db-1', name: 'Bread', price: 11 },
          { id: 'db-2', name: 'Half Bread', price: 5.50 },
          { id: 'db-3', name: 'Yellow Buns', price: 38 },
          { id: 'db-4', name: 'Polony Buns', price: 14 },
          { id: 'db-5', name: 'Hotdog Buns', price: 17 },
          { id: 'db-6', name: 'White Rolls (x4)', price: 15 },
          { id: 'db-7', name: 'Yellow Rolls', price: 12 },
          { id: 'db-8', name: 'Scones', price: 2 },
          { id: 'db-9', name: 'Fatcook', price: 2 },
          { id: 'db-10', name: 'Ginger', price: 3 },
          { id: 'db-11', name: 'Hotdog', price: 10 },
          { id: 'db-12', name: 'Muffin', price: 12 },
        ],
      },
      {
        key: 'schoolbuns',
        label: 'School Buns',
        items: [
          { id: 'dsb-1', name: 'School Buns (6-pack)', price: 30 },
          { id: 'dsb-2', name: 'Mixed School Buns 2', price: 4 },
          { id: 'dsb-3', name: 'Mixed School Buns 3', price: 6 },
          { id: 'dsb-4', name: 'Mixed School Buns 4', price: 8 },
          { id: 'dsb-5', name: 'Mixed School Buns 5', price: 10 },
          { id: 'dsb-6', name: 'Mixed School Buns 6', price: 12 },
          { id: 'dsb-7', name: 'Mixed School Buns 12', price: 23 },
          { id: 'dsb-8', name: 'Yellow School Buns 4', price: 9 },
          { id: 'dsb-9', name: 'Yellow School Buns 12', price: 25 },
          { id: 'dsb-10', name: 'School Bun Polony & Atchaar', price: 7 },
          { id: 'db-13', name: 'School Bun Rama', price: 13 },
        ],
      },
      {
        key: 'sandwiches',
        label: 'Sandwiches',
        items: [
          { id: 'ds-1', name: 'Sandwich S8', price: 8 },
          { id: 'ds-2', name: 'Sandwich S11', price: 11 },
          { id: 'ds-3', name: 'Sandwich S13', price: 13 },
          { id: 'ds-4', name: 'Sandwich S15', price: 15 },
          { id: 'ds-5', name: 'Sandwich S17', price: 17 },
          { id: 'ds-6', name: 'Sandwich S18', price: 18 },
          { id: 'ds-7', name: 'Sandwich S19', price: 19 },
          { id: 'ds-8', name: 'Sandwich S21', price: 21 },
          { id: 'ds-9', name: 'Sandwich S23', price: 23 },
        ],
      },
      {
        key: 'soft-drinks',
        label: 'Soft Drinks',
        items: [
          { id: 'ts-1', name: 'Predator 500ml', price: 12 },
          { id: 'ts-2', name: 'Play 500ml', price: 16 },
          { id: 'ts-3', name: 'Coke Can 500ml', price: 14 },
          { id: 'ts-4', name: 'Coke 1.25L', price: 14.50 },
          { id: 'ts-5', name: 'Coke 1L', price: 20 },
          { id: 'ts-6', name: 'Coke 440ml', price: 14 },
          { id: 'ts-7', name: 'Fanta Orange 1.25L', price: 14.50 },
          { id: 'ts-8', name: 'Fanta Grape 1.25L', price: 14.50 },
          { id: 'ts-9', name: 'Oasis 1.5L', price: 13 },
          { id: 'ts-10', name: 'Dragon 500ml', price: 12 },
          { id: 'ts-11', name: 'My Size Coke', price: 10 },
        ],
      },
      {
        key: 'tea-coffee',
        label: 'Tea & Coffee',
        items: [
          { id: 'ts-12', name: 'Hug in a Mug', price: 18 },
          { id: 'ts-13', name: 'Five Roses Tea', price: 8 },
          { id: 'ts-14', name: 'Joko Tea', price: 8 },
          { id: 'ts-15', name: 'Rooibos Tea', price: 8 },
          { id: 'ts-16', name: 'Ricoffy', price: 8 },
          { id: 'ts-17', name: 'Enrista Mild Coffee', price: 14 },
        ],
      },
      {
        key: 'sweets-chips',
        label: 'Sweets & Chips',
        items: [
          { id: 'ts-18', name: 'Snack It 100g', price: 5 },
          { id: 'ts-19', name: 'Chappies', price: 0.50 },
          { id: 'ts-20', name: 'Pin Pop', price: 1.50 },
          { id: 'ts-21', name: 'Baby Sweets', price: 1 },
        ],
      },
      {
        key: 'miscellaneous',
        label: 'Miscellaneous',
        items: [
          { id: 'ts-22', name: 'Grandpa', price: 3.50 },
          { id: 'ts-23', name: 'Cups', price: 1.50 },
          { id: 'ts-24', name: 'Gravy', price: 7 },
        ],
      },
    ],
  },
  {
    key: 'yawehs',
    label: "Yahweh's Delight",
    gateway: 'yoco',
    cardEnabled: true,
    branches: [
      { key: 'limpopo', label: 'Limpopo', address: 'Limpopo, South Africa' },
      { key: 'pretoria', label: 'Pretoria', address: 'Pretoria, South Africa' },
    ],
    categories: [
      {
        key: 'daily-bread',
        label: 'Daily Bread',
        items: [
          { id: 'yd-1', name: 'White Bread', price: 13 },
          { id: 'yd-2', name: 'Brown Bread', price: 12 },
          { id: 'yd-3', name: 'Half White', price: 6 },
          { id: 'yd-4', name: 'Half Brown', price: 6 },
          { id: 'yd-5', name: 'Kota Bread', price: 4 },
        ],
      },
      {
        key: 'schoolbuns',
        label: 'School Buns',
        items: [
          { id: 'ysb-1', name: '20 School Buns', price: 50 },
          { id: 'ysb-2', name: '12 School Buns', price: 30 },
          { id: 'ysb-3', name: '8 School Buns', price: 20 },
          { id: 'ysb-4', name: '6 School Buns', price: 15 },
          { id: 'ysb-5', name: '4 School Buns', price: 10 },
          { id: 'ysb-6', name: '2 School Buns', price: 5 },
        ],
      },
      {
        key: 'schoolbuns-sandwiches',
        label: 'Schoolbuns Sandwiches',
        items: [
          { id: 'ysbs-1', name: 'Polony n Cheese 4SCB', price: 20 },
          { id: 'ysbs-2', name: '4 SCB Rama', price: 12 },
          { id: 'ysbs-3', name: 'Scb Polony & Rama', price: 16 },
          { id: 'ysbs-4', name: '2 Scb Pol & Atchaar', price: 10 },
          { id: 'ysbs-5', name: 'Atchaar Container', price: 6 },
        ],
      },
      {
        key: 'rolls-buns',
        label: 'Rolls & Buns',
        items: [
          { id: 'yr-8', name: '1 White Roll', price: 3 },
          { id: 'yr-9', name: '1 Yellow Roll', price: 4 },
          { id: 'yr-1', name: 'Yellow Rolls (6)', price: 16 },
          { id: 'yr-2', name: '2 Yellow Rolls', price: 8 },
          { id: 'yr-3', name: '2 White Rolls', price: 6 },
          { id: 'yr-4', name: '6 Hamburger Rolls', price: 18 },
          { id: 'yr-5', name: 'Roll + Polony + Cheese', price: 10 },
          { id: 'yd-6', name: 'Hotdog Rolls', price: 21 },
        ],
      },
      {
        key: 'kota',
        label: 'Kota',
        items: [
          { id: 'yk-1', name: 'Standard Kota', price: 20 },
          { id: 'yk-2', name: 'Half Vienna', price: 25 },
          { id: 'yk-3', name: 'Atchaar, Chips & Vienna', price: 25 },
          { id: 'yk-4', name: 'Full Vienna', price: 28 },
          { id: 'yk-5', name: 'Half Russian', price: 33 },
          { id: 'yk-6', name: 'Full Russian', price: 37 },
          { id: 'yk-7', name: 'Patty + Vienna', price: 45 },
          { id: 'yk-8', name: 'Patty + Russian', price: 55 },
          { id: 'yk-9', name: 'Cheese (add-on)', price: 4 },
          { id: 'yk-10', name: 'Fried Egg (add-on)', price: 4 },
        ],
      },
      {
        key: 'sandwiches',
        label: 'Sandwiches & Toast',
        items: [
          { id: 'ys-1', name: 'Polony & Cheese', price: 17 },
          { id: 'ys-2', name: 'Cheese & Tomato', price: 23 },
          { id: 'ys-3', name: 'Boiled Egg Sandwich', price: 27 },
          { id: 'ys-4', name: 'Bacon & Cheese', price: 30 },
          { id: 'ys-5', name: 'Bacon, Egg, Cheese', price: 35 },
          { id: 'ys-6', name: 'Chicken Mayo Sandwich', price: 35 },
          { id: 'ys-7', name: 'Dagwood', price: 35 },
          { id: 'ys-8', name: 'Hotdog', price: 12 },
          { id: 'ys-9', name: 'Plain Toast', price: 13 },
          { id: 'ys-10', name: '3 Hotdog', price: 11 },
        ],
      },
      {
        key: 'fast-food',
        label: 'Fast Food',
        items: [
          { id: 'yf-1', name: 'Vienna', price: 7 },
          { id: 'yf-2', name: 'Russian', price: 9 },
          { id: 'yf-4', name: 'Small Chips', price: 19 },
          { id: 'yf-5', name: 'Medium Chips', price: 27 },
          { id: 'yf-6', name: 'Large Chips', price: 38 },
          { id: 'yf-7', name: 'Burger Patty', price: 35 },
        ],
      },
      {
        key: 'quick-bakes',
        label: 'Quick Bakes',
        items: [
          { id: 'yq-1', name: 'Fatcook', price: 3 },
          { id: 'yq-2', name: 'Scones', price: 3 },
          { id: 'yq-3', name: '2 Magwinya Polony & Atchaar', price: 10 },
          { id: 'yq-4', name: 'Jam Square', price: 16 },
        ],
      },
      {
        key: 'sweet-tings',
        label: 'Sweet Tings',
        items: [
          { id: 'yt-1', name: 'Muffin Vanilla', price: 15 },
          { id: 'yt-2', name: 'Red Velvet Cake Cup', price: 29 },
          { id: 'yt-3', name: 'Vanilla Cake Cup', price: 19 },
          { id: 'yt-4', name: 'Chocolate Cake Cup', price: 23 },
        ],
      },
      {
        key: 'sweets',
        label: 'Sweets',
        items: [
          { id: 'ysw-1', name: 'Halls', price: 1 },
          { id: 'ysw-2', name: 'Chappies', price: 1 },
        ],
      },
      {
        key: 'buttered-bread',
        label: 'Buttered Bread',
        items: [
          { id: 'ybb-1', name: 'Kota Rama & Jam', price: 8 },
          { id: 'ybb-2', name: 'Kota Peanut Butter & Jam', price: 12 },
          { id: 'ybb-3', name: 'Half Jam & Rama', price: 15 },
          { id: 'ybb-4', name: 'Half Peanut Butter & Jam', price: 18 },
        ],
      },
      {
        key: 'coffee-tea',
        label: 'Coffee & Tea',
        items: [
          { id: 'yct-1', name: 'Ricoffy', price: 13 },
          { id: 'yct-2', name: '3in1 Ricoffy', price: 17 },
          { id: 'yct-3', name: 'Jacobs', price: 15 },
          { id: 'yct-4', name: 'Cappuccino', price: 25 },
          { id: 'yct-5', name: 'Enrista', price: 27 },
          { id: 'yct-6', name: 'Fresh Milk', price: 3 },
          { id: 'yct-7', name: 'Five Roses', price: 12 },
          { id: 'yct-8', name: 'Joko', price: 12 },
          { id: 'yct-9', name: 'Rooibos', price: 10 },
          { id: 'yct-10', name: 'No Milk Tea', price: 10 },
        ],
      },
      {
        key: 'extras',
        label: 'Extras',
        items: [
          { id: 'ye-1', name: 'Boiled Egg', price: 4 },
          { id: 'ye-2', name: 'Half Polony Slice', price: 1 },
          { id: 'ye-3', name: 'Plastic', price: 1 },
          { id: 'ye-4', name: 'Jam Squares', price: 8.5 },
        ],
      },
      {
        key: 'supply-donuts',
        label: 'Supply Donuts',
        items: [
          { id: 'ysd-1', name: 'Chocolate Donuts (retail price)', price: 15 },
          { id: 'ysd-2', name: 'Vanilla Glazed Donuts (retail price)', price: 12 },
        ],
      },
      {
        key: 'bento-cakes',
        label: 'Bento Cakes & Boxes',
        items: [
          { id: 'ybc-1', name: '2-inch Designed Mini Cake', price: 65 },
          { id: 'ybc-2', name: '4 inch Vanilla Bento Cake', price: 450 },
          { id: 'ybc-3', name: '4 inch Chocolate Bento Cake', price: 460 },
          { id: 'ybc-4', name: '4 inch Red Velvet Bento Cake', price: 490 },
          { id: 'ybc-5', name: 'Standard Bento Box', price: 650 },
          { id: 'ybc-6', name: 'Gourmet Bento Box', price: 720 },
          { id: 'ybc-7', name: 'Heart Bento Box', price: 680 },
          { id: 'ybc-8', name: 'Custom Design', price: 50 },
        ],
      },
      {
        key: 'cake-addons',
        label: 'Cake Add-Ons',
        items: [
          { id: 'yca-1', name: 'Writing on Cake', price: 50 },
          { id: 'yca-2', name: 'Artificial Florals', price: 10 },
          { id: 'yca-3', name: 'Late Order Fee', price: 60 },
          { id: 'yca-4', name: 'Edible Printing', price: 100 },
        ],
      },
      {
        key: 'custom-cake',
        label: 'Customise my Cake',
        externalLink: 'https://www.yahwehsdelight.co.za/',
        items: [],
      },
    ],
  },
]
